export const baseInput = {
  props: {
    label: String,
    name: String,
    autocomplete: String,
    placeholder: String,
    linecount: Number,
    pattern: String,
    required: Boolean,
    value: String,
    type: String,
    autofocus: Boolean
  },
  computed: {
    inputPattern: function () {
      return this.$props.pattern ? this.$props.pattern : ".+";
    },
    isRequired: function () {
      return this.$props.required;
    },
    inputType: function () {
      return this.$props.type != "" ? this.$props.type : "text";
    },
    isAutoFocus: function () {
      return this.$props.autofocus ? 'autofocus' : '';
    }
  },
  watch: {
    value: function (v) {
      const ctrl = this.$refs.formControl;
      if (ctrl) {
        if (ctrl.value.length > 0) {
          ctrl.classList.add('dirty');
        } else {
          ctrl.classList.remove('dirty');
        }
      }
    },
  },
  methods: {
    update: function () {
      const ctrl = this.$refs.formControl;
      if (ctrl) {
        if (ctrl.value.length > 0) {
          ctrl.classList.add('dirty');
        } else {
          ctrl.classList.remove('dirty');
        }
        this.$emit('input', ctrl.value);
      }
    }
  }
};